import { createAsyncThunk } from '@reduxjs/toolkit';
import { reloadUserProjectPositions } from '../../api/user-project-positions';

export const reloadUserProjectPositionsAsync = createAsyncThunk(
  'userProjectPositions/reloadUserProjectPositions',
  reloadUserProjectPositions
);
